export default function MenuBlock({ settings }) {
  const { padding, margin, backgroundColor } = settings

  const containerStyle = {
    padding: `${padding.top} ${padding.right} ${padding.bottom} ${padding.left}`,
    margin: `${margin.top} ${margin.right} ${margin.bottom} ${margin.left}`,
    backgroundColor: backgroundColor || 'transparent',
    fontSize: settings.fontSize,
    fontFamily: settings.fontFamily,
    textAlign: settings.textAlign
  }

  const linkStyle = {
    color: settings.color,
    textDecoration: 'none',
    marginRight: settings.orientation === 'horizontal' ? '8px' : '0',
    display: settings.orientation === 'vertical' ? 'block' : 'inline'
  }

  return (
    <div style={containerStyle}>
      {settings.links.map((link, idx) => (
        <span key={idx}>
          <a href={link.url} style={linkStyle}>
            {link.text}
          </a>
          {idx < settings.links.length - 1 && settings.orientation === 'horizontal' && (
            <span>{settings.separator}</span>
          )}
        </span>
      ))}
    </div>
  )
}
